import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { FormFieldInput } from '../../../../../../../global/form/form-field-input/form-field-input';
import { EnablementStatus } from '../../../../../../../../constants/common.constants';
import { FormFieldProps } from '../../../../../../../../infrastructure/form-viewmodel-controller';
import { MODULE_EVENTS_DAYS_SUFFIX_TEXT } from '../../../../../../event-hubs.text';
import { MAX_EVENTS_DAYS, MIN_EVENTS_DAYS } from './events-module.config';

type EventsRangeProps = {
    displayedField: FormFieldProps;
    daysField: FormFieldProps;
    displayedLabel: MessageDescriptor;
    daysPrefixLabel: MessageDescriptor;
    defaultDays: number;
};

export const EventsRange: React.FC<EventsRangeProps> = observer(props => {
    const { displayedField, daysField, displayedLabel, daysPrefixLabel, defaultDays } = props;

    const enabled = displayedField.value as boolean;
    const hasDaysError = !daysField.valid && daysField.touched;

    const handleToggle = () => {
        const nextEnabled = !enabled;
        displayedField.setValue(nextEnabled);
        if (!nextEnabled) {
            daysField.setValue(defaultDays);
        }
    };

    return (
        <div className='events-module-modal__events-range'>
            <div className='events-module-modal__events-range-row'>
                <FormFieldInput.Toggle
                    isSelected={enabled}
                    toggle={handleToggle}
                    text={<FormattedMessage
                        values={{ suffix: enabled ? EnablementStatus.DISPLAYED : EnablementStatus.NOT_DISPLAYED }}
                        {...displayedLabel}
                    />}
                    className='events-module-modal__toggle-row events-module-modal__events-range-toggle'
                    overrideDefaultClassName
                />
                <div className={`events-module-modal__events-days ${enabled ? '' : 'events-module-modal__events-days--disabled'}`}>
                    <span className='events-module-modal__events-days-prefix'>
                        <FormattedMessage {...daysPrefixLabel} />
                    </span>
                    <input
                        className='oe-form-field__control events-module-modal__events-days-input'
                        type='number'
                        min={MIN_EVENTS_DAYS}
                        max={MAX_EVENTS_DAYS}
                        value={(daysField.value ?? '') as string | number}
                        onChange={e => daysField.setValue(e.target.value)}
                        onBlur={daysField.setTouched}
                        disabled={!enabled}
                    />
                    <span className='events-module-modal__events-days-suffix'>
                        <FormattedMessage {...MODULE_EVENTS_DAYS_SUFFIX_TEXT} />
                    </span>
                </div>
            </div>
            {hasDaysError && (
                <span className='oe-form-field__error'>
                    <FormattedMessage {...daysField.validationMessage} />
                </span>
            )}
        </div>
    );
});
